export const Placeholder = ({ children, className = "" }) => (
  <span
    data-testid="content-placeholder"
    className={`inline-flex items-center rounded-md border border-dashed border-[#C6A04A]/60 bg-[#C6A04A]/10 px-2 py-0.5 text-[0.72rem] font-medium tracking-wide text-[#8a6d1f] ${className}`}
  >
    {children}
  </span>
);
